// extracted by mini-css-extract-plugin
export default {"article_lines_container":"article-lines-tab_article_lines_container__vEsR1"};